<template>
    <div class="login-container">
        <div class="login-main">
            <img
                src="../../assets/img/newerp_button1.png"
                class="left-logo"
                alt=""
            />
            <img
                src="https://cdn.spbcn.org/spbcnWeb/spbcn/logo-season12.png"
                class="left-logo2"
                alt=""
            />
            <div class="login-box">
                <div class="login-header">
                    <div class="login-title">ERP管理系统登录</div>
                    <div class="login-sub-title">ERP Management System Login</div>
                </div>
                <el-form
                    ref="loginFormRef"
                    class="login_form"
                    :rules="loginFormRules"
                    :model="loginForm"
                >
                    <el-form-item
                        prop="phone"
                        label="手机号 | Mobile Phone Number"
                        class="mobile-item"
                    >
                        <el-input
                            class="input"
                            v-model="loginForm.phone"
                            prefix-icon="iconfont icon-user"
                            placeholder="请输入手机号"
                        ></el-input>
                    </el-form-item>
                    <el-form-item
                        prop="code"
                        label="验证码 | Verification Code"
                        class="code-item"
                    >
                        <el-input
                            class="input"
                            v-model="loginForm.code"
                            prefix-icon="iconfont icon-key"
                            type="code"
                            placeholder="请输入短信验证码"
                        >
                            <el-button
                                class="send-btn"
                                :loading="sending"
                                :disabled="sendDisabled"
                                @click="sendSmsClicked"
                                slot="suffix"
                                >{{ sendButtonText }}</el-button
                            >
                        </el-input>
                    </el-form-item>
                    <el-form-item class="btns">
                        <el-button
                            class="login-btn"
                            type="primary"
                            @click="mainLogin"
                            @keyup.enter="mainLogin(e)"
                            >立即登录</el-button
                        >
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="login-footer">
            © 2014-2026 spbcn.org 版权所有 | 京ICP备17055067号
        </div>
        <!-- 选择用户的Dialog -->
        <el-dialog
            title="选择身份"
            :visible.sync="selectUserDialogViaible"
            width="50%"
        >
            <el-table
                header-cell-class-name="tableHeaderStyle"
                :data="userList"
                border
                stripe
            >
                <!-- <el-table-column label="部门" prop="deptName"></el-table-column> -->
                <el-table-column label="岗位" prop="name"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            style="cursor: pointer"
                            size="mini"
                            @click="userLogin(scope.row)"
                            >登录</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>
    </div>
</template>

<script>
import { onSendSms, chnEngLoginRequest, listByLogin, setIdentity } from '../../http/api'
// import storage from '../../store/storage'
export default {
  data () {
    return {
      loginForm: {
        phone: '',
        code: ''
      },
      loginFormRules: {
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请输入短信验证码', trigger: 'blur' }
        ]
      },
      userList: [],
      selectUserDialogViaible: false,
      sending: false,
      sendDisabled: false,
      loading: false,
      timer: 0
    }
  },
  mounted () {
    // 绑定监听事件
    window.addEventListener('keydown', this.keyDown)
  },
  destroyed () {
    // 销毁事件
    window.removeEventListener('keydown', this.keyDown, false)
  },
  created () {
    localStorage.removeItem('Authorization') // 移除token，跳转至登录
    const lastSendTime = window.sessionStorage.getItem('last-send-time')
    if (lastSendTime) {
      const timer = 60 - this.$moment(new Date()).diff(this.$moment(lastSendTime), 'seconds')
      if (timer > 0) this.sendDisabled = true
      this.timer = timer > 0 ? timer : 0
    }
  },
  methods: {
    // 点击回车键登录
    keyDown (e) {
      // 回车则执行登录方法 enter键的ASCII是13
      if (e.keyCode === 13) {
        this.mainLogin() // 定义的登录方法
      }
    },
    resetLoginForm () {
      this.$refs.loginFormRef.resetFields()
    },
    // 选择身份后登录
    userLogin (erpUserData) {
      console.log('erpUserData', erpUserData)
      setIdentity({ id: erpUserData.id }).then((res) => {
        console.log('loginRes', res)
        this.$store.commit('SET_JOBINFO', erpUserData)
        this.$store.commit('SET_PERMISSION', res.data.roleMenus)
        this.$store.commit('SET_MENULIST', res.data.directoryMenus)
        this.$store.commit('SET_FLAG', erpUserData.wildcard)
        this.$store.commit('SET_TOP_MENUS', [])
        this.$store.commit('SET_ACTIVE_TOP_MENU_ID', '')
        this.$store.commit('SET_ACTIVE_MENU_ID', '')
        this.$router.push('/home')
      }).catch((err) => {
        console.log('返回的err', err)
      })
    },
    // 获取短信
    sendSmsClicked () {
      onSendSms({ phone: this.loginForm.phone, codeType: this.$chnEngStatusCode.LOGINSMSTYPE }).then((res) => {
        this.$message.success('短信发送成功，请注意查收')
        window.sessionStorage.setItem('loginLast-send-time', new Date())
        this.timer = 60
        this.sendDisabled = true
      }).catch((err) => {
        console.log('err', err)
      })
    },
    // 登录
    mainLogin () {
      const formData = new FormData()
      formData.append('phone', this.loginForm.phone)
      formData.append('code', this.loginForm.code)
      formData.append('type', this.$chnEngStatusCode.LOGINTYPE)
      formData.append('codeType', this.$chnEngStatusCode.LOGINSMSTYPE)
      this.$refs.loginFormRef.validate(async valid => {
        if (!valid) return
        this.isLogonState = true
        chnEngLoginRequest(formData).then((res) => {
          console.log('mainLoginres', res)
          this.getUserRoleList()
        }).catch(() => {
          this.isLogonState = false
        })
      })
    },
    // 获取用户岗位信息
    getUserRoleList () {
      listByLogin().then((res) => {
        switch (res.data.length) {
          case 0:
            return this.$message.error('该账号下未设置身份信息')
          case 1:
            this.userLogin(res.data[0])
            break
          default:
            this.userList = res.data
            this.selectUserDialogViaible = true
            break
        }
      }).catch((err) => {
        console.log('返回的err', err)
      })
    }
  },
  computed: {
    sendButtonText () {
      if (this.timer === 0) {
        return '发送验证码'
      } else {
        return `${this.timer}秒后重发`
      }
    }
  },
  watch: {
    timer (num) {
      if (num > 0) {
        setTimeout(() => {
          this.timer = --num
        }, 1000)
      } else {
        this.sendDisabled = false
      }
    }
  }
}
</script>

<style lang="less" scoped>
.login-container {
    height: 100%;
    min-height: 100vh;
    // background-image: url(https://cdn.spbcn.org/spbcnWeb/spbcn/spbcn_web_bg_11.png);
    background-image: url(https://cdn.spbcn.org/spbcnWeb/spbcn/spbcn_web_bg_12.jpg);
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    position: relative;

    .login-main {
        width: 100%;
        height: 100%;
        min-height: 100vh;
        position: relative;
    }

    .login-footer {
        position: absolute;
        left: 50%;
        bottom: 20px;
        transform: translateX(-50%);
        z-index: 2;
        color: #fff;
        font-size: 12px;
        line-height: 1.4;
        text-align: center;
        white-space: nowrap;
    }

    .left-logo {
        position: fixed;
        top: 30px;
        left: 42px;
        width: auto;
        height: 42px;
        z-index: 3;
    }
    .left-logo2{
      position: fixed;
      top: 34px;
      left: 220px;
      width: auto;
      height: 36px;
      z-index: 3;
      object-fit: contain;
    }

    .left-icon {
        position: fixed;
        left: 36px;
        bottom: 36px;
        z-index: 2;

        img {
            width: min(15vw, 760px);
            height: auto;
        }
    }

    .login-box {
        width: 420px;
        height: 100vh;
        margin-left: auto;
        padding: 110px 34px 0;
        box-sizing: border-box;
        background-color: rgba(0, 0, 0, 0.38);
        color: #fff;
        position: relative;
        z-index: 3;
    }

    .login-header {
        margin-bottom: 30px;

        .login-title {
            font-size: 36px;
            font-weight: 700;
            line-height: 1.2;
            color: #fff;
        }

        .login-sub-title {
            font-size: 11px;
            margin-top: 6px;
            color: rgba(255, 255, 255, 0.9);
            letter-spacing: 0.6px;
        }
    }

    .login_form {
        ::v-deep .el-form-item__label {
            color: #fff;
            line-height: 18px;
            padding-bottom: 8px;
        }
    }

    .mobile-item {
        margin-top: 20px;
        margin-bottom: 16px;
    }

    .code-item {
        margin-bottom: 18px;
    }

    .input ::v-deep .el-input__inner {
        border-radius: 0;
        border: 1px solid rgba(255, 255, 255, 0.7);
        background-color: transparent;
        color: #fff;
    }

    .input ::v-deep .el-input__prefix {
        color: rgba(255, 255, 255, 0.85);
    }

    .code-item ::v-deep .el-input__suffix {
        right: 0;
    }

    .send-btn {
        border: none;
        border-radius: 0;
        color: #f9d64a;
        background-color: transparent;

        &:hover,
        &:focus {
            color: #f9d64a;
            background-color: transparent;
        }
    }

    .btns {
        margin-top: 44px;
        margin-bottom: 0;
        display: flex;
        justify-content: center;

        ::v-deep .el-form-item__content {
            width: 100%;
        }
    }

    .login-btn {
        width: 100%;
        height: 42px;
        border-radius: 2px;
        border: none;
        font-size: 16px;
        font-weight: 700;
        color: #111;
        background-color: #fcd937;
    }
}
</style>
